import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class ExtencionService {

  url = environment.baseUrl+ '/api/ExtencionServicio';

  constructor(private http: HttpClient) {}

  permiteExtencionesServicios(): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/PermiteExtencionesServicios', {}, httpOption);
  }

  addExtencionServicio(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/AddExtencionServicio', obj, httpOption);
  }

  getExtencionesServicios(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetExtencionesServicios', obj, httpOption);
  }
}